'use client';

import { useEffect, useState } from 'react';
import { Checkbox, Typography } from '@mui/material';
import { checkIsPreventedDisplyForWeek, setPreventDisplyForWeek } from '@/utils/modal.util';
import FlexBox from '@/components/FlexBox';
import BaseModal from '@/components/modal/BaseModal';

const AllPageNoticeModal = ({
  modalTitle,
  children,
  localStorageItemName,
  noticePeriodEndString
}: {
  modalTitle: string;
  children: React.ReactNode;
  localStorageItemName: string;
  noticePeriodEndString: string;
}) => {
  const [showModal, setShowModal] = useState(false);
  const [notShowModalForWeek, setNotShowModalForWeek] = useState(false);

  const checkTodayIsInNoticePeriod = (): boolean => {
    const noticePeriodEnd = new Date(noticePeriodEndString).getTime();
    const now = Date.now();

    return noticePeriodEnd > now;
  };

  useEffect(() => {
    const isTodayNoticeDay = checkTodayIsInNoticePeriod();
    if (isTodayNoticeDay) {
      setShowModal(!checkIsPreventedDisplyForWeek(localStorageItemName));
    }
  }, []);

  return showModal ? (
    <BaseModal
      modalTitle={modalTitle}
      showModal={showModal}
      handleShowModal={() => setShowModal(!showModal)}
      onCloseModal={async () => {
        if (notShowModalForWeek) {
          setPreventDisplyForWeek(localStorageItemName, !notShowModalForWeek);
        }
      }}
    >
      <FlexBox style={{ flexDirection: 'column', alignItems: 'left' }}>
        {children}
        <FlexBox style={{ justifyContent: 'left', marginTop: '12px' }}>
          <Checkbox
            checked={notShowModalForWeek}
            color="success"
            sx={{ paddingLeft: 0 }}
            onChange={(e) => {
              const isChecked = (e.currentTarget as HTMLInputElement)?.checked;
              setNotShowModalForWeek(isChecked);
            }}
          />
          <Typography color="text">일주일간 보지 않기</Typography>
        </FlexBox>
      </FlexBox>
    </BaseModal>
  ) : (
    ''
  );
};

export default AllPageNoticeModal;
